import { AdminIndexTable } from "../components/AdminIndexTable";
import { Logger } from "../../utils/Logger";

const CTRL_TAG = "AdminWorkCategoryController";

function bindAutoSlug(scope: HTMLElement): void {
    const labelInput = scope.querySelector<HTMLInputElement>("[data-wc-label]");
    const slugInput = scope.querySelector<HTMLInputElement>("[data-wc-slug]");
    if (!labelInput || !slugInput) return;

    let userEditedSlug = false;

    slugInput.addEventListener("input", () => {
        userEditedSlug = slugInput.value.trim() !== "";
    });

    labelInput.addEventListener("input", () => {
        if (userEditedSlug) return;
        slugInput.value = labelInput.value
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-_]/g, "")
            .replace(/-+/g, "-")
            .replace(/^-|-$/g, "");
    });
}

export const AdminWorkCategoryController = {
    index(): void {
        Logger.debug(`${CTRL_TAG}.index`);
        const page = document.querySelector<HTMLElement>(".admin-work-categories");
        if (!page) return;
        bindAutoSlug(page);
        new AdminIndexTable({ pageSelector: ".admin-work-categories" }).init();
    },
};
